import * as THREE from 'three';

export interface NodeState {
  [objectId: number]: boolean;
}

export function getObjectDisplayName(
  object: THREE.Object3D,
  index?: number
): string {
  if (object.name && object.name.trim() !== '') {
    return object.name;
  }

  const type = object.type;
  const suffix = index !== undefined ? `_${index}` : '';

  return `${type}${suffix}`;
}

export function getObjectType(object: THREE.Object3D): string {
  switch (object.type) {
    case 'Scene':
      return 'Scene';
    case 'PerspectiveCamera':
    case 'OrthographicCamera':
      return 'Camera';
    case 'Mesh':
      return 'Mesh';
    case 'Line':
    case 'LineSegments':
      return 'Line';
    case 'Points':
      return 'Points';
    default:
      if (object.type.includes('Light')) {
        return 'Light';
      }
      return 'Object3D';
  }
}

export function isSelectableObject(object: THREE.Object3D): boolean {
  const nonSelectableTypes = ['GridHelper', 'AxesHelper'];
  return !nonSelectableTypes.includes(object.type);
}

export function shouldShowInHierarchy(object: THREE.Object3D): boolean {
  // Only exclude very specific internal objects
  const excludeTypes = ['GridHelper', 'AxesHelper'];
  const excludeNames = ['__r3f', '__r3f-group'];

  return (
    !excludeTypes.includes(object.type) &&
    !excludeNames.some((name) => object.name?.includes(name))
  );
}
